import React, { useState, useEffect } from 'react';
import { Button, Progress } from 'antd';

const ProgressBar = ({ timeValue, isActive }) => {
  const [progress, setProgress] = useState(0);
  const [hide, setHide] = useState(!isActive);
  const [time, setTime] = useState(timeValue || 10000); // Default time in milliseconds

  useEffect(() => {
    setHide(!isActive)
  }, [isActive]);

  useEffect(() => {
    let interval;
    if (!hide) {
      const intervalDuration = time / 100; // Calculate interval duration based on time
      interval = setInterval(() => {
        // Update progress state every interval duration until it reaches 100
        setProgress((prevProgress) => {
          if (prevProgress < 100) {
            return prevProgress + 1;
          } else {
            return 0; // Reset progress to 0 when it reaches 100
          }
        });
      }, intervalDuration);
    } else {
      setProgress(0)
    }
    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [hide, time]);

  const handleHideButtonClick = () => {
    setHide(true); // Set hide to true when button is clicked
  };

  const handleShowButtonClick = () => {
    setHide(false); // Set hide to false when button is clicked
  };

  const handleTimeChange = (e) => {
    setTime(parseInt(e.target.value)); // Set the time based on the input value
  };

  return (
    <div style={{ marginRight: 10 }}>
      <Progress percent={progress} showInfo={false} strokeColor={'#b48ae1'} />
      {/*<br/>*/}
      {/*<input type="number" value={time} onChange={handleTimeChange}/>*/}
      {/*<br/>*/}
      {/*<Button onClick={handleHideButtonClick}>Hide Progress</Button>*/}
      {/*<Button onClick={handleShowButtonClick}>Show Progress</Button>*/}
    </div>
  );
};

export default ProgressBar;
